import OfficialDocumentDetail from '@/views/backstage/structure/detail_page/OfficialDocumentDetailStructure'
import GraphDetail from '@/views/backstage/structure/detail_page/GraphDetailStructure'
import PublicationDetail from '@/views/backstage/structure/detail_page/PublicationDetailStructure'
import ImageDetail from '@/views/backstage/structure/detail_page/ImageDetailStructure'
import CulturalRelicsDetail from '@/views/backstage/structure/detail_page/CulturalRelicsDetailStructure'
import OralHistoryDetail from '@/views/backstage/structure/detail_page/OralHistoryDetailStructure'
import CultureNaturalLandscapeDetail from '@/views/backstage/structure/detail_page/CultureNaturalLandscapeDetailStructure'
import BuildingsDetail from '@/views/backstage/structure/detail_page/BuildingsDetailStructure'

export default (detail_page_type) => {
    switch (detail_page_type) {
    case 'official_document': return OfficialDocumentDetail();
    case 'graph': return GraphDetail();
    case 'publication': return PublicationDetail();
    case 'image': return ImageDetail();
    case 'cultural_relics': return CulturalRelicsDetail();
    case 'oral_history': return OralHistoryDetail();
    case 'culture_natural_landscape': return CultureNaturalLandscapeDetail();
    case 'buildings': return BuildingsDetail();
    default: return []
    }
}
